import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ANIMAL_EVENT_LIST_VIEW,
  NEW_ANIMAL_EVENT_VIEW,
} from "../../routes/route-list"
import { AddEventIcon } from "@/assets/widgets/add-event-icon.tsx"
import { useGetAllAnimalEventsQuery } from "@/features/events/animal-events/api/animal-events-api.ts"
import { AnimalEventsCard } from "@/features/events/animal-events/components/animal-events-card/animal-events-card.tsx"
import EmptyContentCreateItemButton from "@/features/home/components/empty-content-create-item-button/empty-content-create-item-button.tsx"
import WidgetHeader from "@/features/home/components/widget-header/widget-header.tsx"

export const AnimalEventsSummaryWidget = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: events = [] } = useGetAllAnimalEventsQuery()

  const addItemsGoToAction =
    events && events?.length > 0
      ? () => navigate(NEW_ANIMAL_EVENT_VIEW)
      : undefined

  return (
    <div
      className={
        "widget-border box-border flex w-full flex-col gap-5 bg-white px-4 py-4"
      }
    >
      <WidgetHeader
        title={t("animalEvents")}
        navigateTo={ANIMAL_EVENT_LIST_VIEW}
        icon={<AddEventIcon />}
        addItemGoTo={addItemsGoToAction}
      />
      {events && events.length > 0 ? (
        <div className={"flex flex-col gap-2"}>
          {events.slice(0, 3).map((event, index) => (
            <AnimalEventsCard animalEvent={event} key={index} />
          ))}
        </div>
      ) : (
        <EmptyContentCreateItemButton navigateTo={NEW_ANIMAL_EVENT_VIEW} />
      )}
    </div>
  )
}
